export const string = "";
export const number = 0;
export const object = {};
export const array = [];
export const bool = false;
